import React, { forwardRef } from "react";
import { InputGroup, Input as ChakraInput, InputLeftElement, Icon, } from "@chakra-ui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
export const SearchInput = forwardRef(({ placeholder, value, width = "xs", onChange, onKeyDown, onKeyUp, onFocus, onBlur, ...props }, ref) => {
    return (React.createElement(InputGroup, { width: width, maxWidth: "100%", ...props },
        React.createElement(InputLeftElement, { pointerEvents: "none", width: 7 },
            React.createElement(Icon, { as: MagnifyingGlassIcon, boxSize: 3 })),
        React.createElement(ChakraInput, { ref: ref, type: "search", placeholder: placeholder, value: value, paddingLeft: 6, onChange: onChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onBlur: onBlur })));
});
SearchInput.displayName = "SearchInput";
